import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar";
import AppFooter from "./components/appFooter";
import HomePage from "./pages/home";
import Dashboard from "./pages/dashboard";
import UserAccounts from "./pages/profile/UserAccounts";
import ConnectedAccounts from "./pages/profile/ConnectedAccounts";
import FamilyPage from "./pages/profile/Family";
import FaqPage from "./pages/faq";
import Login from "./components/auth/login";
import ConnectBankAccounts from "./pages/onboarding/ConnectBankAccounts";
import { UserProvider } from "./contexts/UserContext";
import Chat from "./pages/Chat";
import TransactionsPage from "./pages/TransactionsPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import Error from "./pages/404";
import AcceptInvitationPage from "./pages/AcceptInvitation";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import TermsOfServicePage from "./pages/tos";
import PrivacyPolicyPage from "./pages/privacy-policy";
import ScrollToTop from "./components/common/ScrollToTop";
import RecurringTransactionsPage from "./pages/RecurringTransactionPage";
import ProfileContainer from "./pages/profile/ProfileContainer";
import WhatsAppLinking from "./pages/WhatsAppLinking";

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/family/invitations" element={<AcceptInvitationPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/whatsapp-link" element={<WhatsAppLinking />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/transactions/all" element={<TransactionsPage />} />
          <Route
            path="/transactions/recurring"
            element={<RecurringTransactionsPage />}
          />
          <Route path="/profile" element={<ProfileContainer />}>
            <Route index element={<Navigate to="accounts" replace />} />
            <Route path="accounts" element={<UserAccounts />} />
            <Route path="banks" element={<ConnectedAccounts />} />
            <Route path="family" element={<FamilyPage />} />
          </Route>
          <Route path="/onboarding/banks" element={<ConnectBankAccounts />} />
          <Route path="/chat" element={<Chat />} />
        </Route>
        {/* Catch-all route for 404 page */}
        <Route path="*" element={<Error />} />
      </Routes>
    </>
  );
}

const queryClient = new QueryClient();

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <UserProvider>
            <div className="flex flex-col min-h-screen">
              <Navbar />
              <main className="flex-grow">
                <AppRoutes />
              </main>
              <AppFooter />
            </div>
          </UserProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
